export enum ShineMigrationType {
  None = 0,
  OL = 1,
  ShineBatiment = 2,
  ShineGC = 3,
  ShineDuo = 4,
}
